import { useEffect, useState } from "react";
import { Accordion, Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { UseUpdateSeller, useGetListingById } from "../../../../api/seller";
import { ReactComponent as Loader } from '../../../../resources/images/Rolling.svg';

export default function GoalEdit(props: any) {
    const [enabled, setEnabled] = useState(false);

    const { data, refetch } = useGetListingById(props?.idSeller, enabled);

    const mutUpdate = useMutation({mutationFn:UseUpdateSeller,
        retry: 0,
        onSuccess: (data) => {
            props.setIsLoading(false);
            props.handleOk();
            props.setData(formState);
        },
        onSettled: (data, error, variables, context) => {
            setIsAccordionOpen(false);
            refetch();
            setActiveId('');
        }
    });

    useEffect(() => {
        if (props?.idSeller) setEnabled(true);
        if (data) setEnabled(false);
    }, [data, props?.idSeller]);

    const [activeId, setActiveId] = useState<string>("");

    const getInitialState = () => {
        return {
            ...props?.data,
            reason: props?.value?.reason_listing === -1 ? 0 : props?.value?.reason_listing,
            explication: props?.value?.desc_reason_listing === "manda_deleted_manda" ? "" : props?.value?.desc_reason_listing,
            acquisiton_type: props?.value?.desired_acquisition === -1 ? 0 : props?.value?.desired_acquisition,
            transaction_duration: props?.value?.urgency === -1 ? 0 : props?.value?.urgency,
        }
    }

    const [formState, setFormState] = useState(getInitialState());
    
    useEffect(() => {
        if(props?.show) setFormState(getInitialState());
    }, [props?.show]);

    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    function toggleActive(id: any) {
        if (activeId === id) {
            setActiveId("");
        } else {
            setActiveId(id);
        }
    }
    useEffect(() => {
        if (Number(formState?.reason) !== 1) {
          setFormState((prevState: any) => ({
            ...prevState,
            explication: "",
          }));
        }
    }, [formState.reason]);

    useEffect(() => {
        if (Number(formState?.reason) === 1 && formState?.explication !== "") {
            props?.setErrorExpCompanyReason(false);
        }
    }, [formState.explication, formState?.reason, props]);

    const updateState = (property: string, value: any) => {
        setFormState((prevState: any) => ({
            ...prevState,
            [property]: value,
        }));
    }

    const save = () => {
        if (Number(formState?.reason) === 0) {
            props?.setErrorCompanyReason(true);
        }
        if (Number(formState?.reason) === 1 && formState?.explication === "") {
            props?.setErrorExpCompanyReason(true);
        }
        if (Number(formState?.acquisiton_type) === 0) {
            props?.setErrorAcquisitionType(true);
        }
        if (Number(formState?.transaction_duration) === 0) {
            props?.setErrorTransaction(true);
        }
        
        if(Number(formState?.reason) !== 0 && ((Number(formState?.reason) === 1 && formState?.explication !== "") || (Number(formState?.reason) !== 1 && formState?.explication === "")) && Number(formState?.acquisiton_type) !== 0 && Number(formState?.transaction_duration) !== 0) {
            props.setIsLoading(true);
            let param = {
                idSeller: props?.idSeller,
                reason_listing: Number(formState?.reason),
                desc_reason_listing: formState?.explication,
                desired_acquisition: Number(formState?.acquisiton_type),
                urgency: Number(formState?.transaction_duration),
            }

            mutUpdate.mutateAsync(param);
        }
    }

    // Enlever les erreurs lors d'un modif
    useEffect(() => {
        if(Number(formState?.reason) !== 0)  props?.setErrorCompanyReason(false);
        if(Number(formState?.reason) === 1 && formState?.explication !== "")  props?.setErrorExpCompanyReason(false);
        if(Number(formState?.acquisiton_type) !== 0)  props?.setErrorAcquisitionType(false);
        if(Number(formState?.transaction_duration) !== 0)  props?.setErrorTransaction(false);
    }, [formState?.reason, props, formState?.explication, formState?.acquisiton_type, formState?.transaction_duration]);

    const handleAccordionOpen = (eventKey: string | null) => {
        if (eventKey && eventKey !== isAccordionOpen.toString()) {
            setIsAccordionOpen(true);
        }
    };

    const setActiveSection = (eventKey: string | null) => {
        handleAccordionOpen(eventKey);
        toggleActive(eventKey);
    };

    const handleExit = () => {
        setIsAccordionOpen(false);
        setActiveId('');
        return  props.handleOk && props.handleOk();
    }

    return (
        <Modal
            show={props.show}
            className='createCompanypopup large forStep5custom buyer-modal'
        >
            <Modal.Header>
                <div className='headerpopupCompany noStep goal'>
                    <h2 className='title'>Goal</h2>
                    <a
                        className='close'
                        onClick={() => !props.isLoading && handleExit()}
                    >
                        <span className='icon-close-pop'></span>
                    </a>
                </div>
            </Modal.Header>

            <Modal.Body className='modal-item-edit'>

                <Accordion defaultActiveKey={activeId}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header onClick={() => setActiveSection('0')}>
                            {
                                activeId !== "0" && (
                                    <div className='container'>
                                        <div className='row'>
                                            <div className='col-md-12 form-group mb-4 required p-0'>
                                                <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>Why are you listing your business in the M&A marketplace?</label>{" "}<span className="hidable">{props?.dataReasonListing?.data?.find((el: any) => el?.id == formState?.reason)?.attributes?.Label}</span>
                                                {
                                                    props?.errorCompanyReason && (
                                                        <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                                            <span className='error-red'> ERROR </span>{" "}
                                                            <span className='txt-error'>This field is required</span>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        {
                                            Number(formState?.reason) === 1 && (
                                                <div className='row'>
                                                    <div className='col-md-12 form-group required p-0 mb-3'>
                                                        <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>Please elaborate why you are interested in finding an acquirer:</label>{" "}<br></br><span className="hidable">{formState?.explication}</span>
                                                        {
                                                            props?.errorExpCompanyReason && (
                                                                <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                                                    <span className='error-red'> ERROR </span>{" "}
                                                                    <span className='txt-error'>This field is required</span>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className='form-group required p-0'>
                                <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>Why are you listing your business in the M&A marketplace?</label>
                                    {
                                        props?.errorCompanyReason && (
                                            <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                                <span className='error-red'> ERROR </span>{" "}
                                                <span className='txt-error'>This field is required</span>
                                            </div>
                                        )
                                    }
                                <select className='form-control mt-2'
                                    name='reason'
                                    onChange={(evt) => updateState(evt.target.name, evt.target.value)}
                                >
                                <option value={0}>Select an option ...</option>
                                    {
                                        props?.dataReasonListing?.data?.map((el : any, index : any) => (
                                            <option selected={el?.id == formState?.reason} value={el?.id} key={index}>{el?.attributes?.Label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            {
                                Number(formState?.reason) === 1 && (
                                    <div className='form-group required p-0 mt-3'>
                                        <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>Please elaborate why you are interested in finding an acquirer:</label>
                                        {
                                            props?.errorExpCompanyReason && (
                                                <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                                    <span className='error-red'> ERROR </span>{" "}
                                                    <span className='txt-error'>This field is required</span>
                                                </div>
                                            )
                                        }
                                        <textarea
                                            name='explication'
                                            className='form-control mt-2'
                                            maxLength={2000}
                                            value={formState?.explication}
                                            onChange={(evt) => {
                                                updateState(evt.target.name, evt.target.value)
                                            }}
                                        />
                                        <span className='caractercount'>
                                            {0 + formState?.explication.length || 0} / 2000
                                        </span>
                                    </div>
                                )
                            }
                            
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header onClick={() => setActiveSection('1')}>
                            <div className='form-group required p-0'>
                                <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>What acquisition type are you aiming for?</label>{" "}<span className="hidable">{props?.dataAcquisitions?.data?.find((el: any) => el?.id == formState?.acquisiton_type)?.attributes?.Label}</span>
                                    {
                                        props?.errorAcquisitionType && (
                                            <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                                <span className='error-red'> ERROR </span>{" "}
                                                <span className='txt-error'>This field is required</span>
                                            </div>
                                        )
                                    }
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <select className='form-control mt-2'
                                name='acquisiton_type'
                                onChange={(evt) => updateState(evt.target.name, evt.target.value)}
                            >
                                <option value={0}>Select an option ...</option>
                                    {
                                        props?.dataAcquisitions?.data?.map((el : any, index : any) => (
                                            <option selected={el?.id == formState?.acquisiton_type} value={el?.id} key={index}>{el?.attributes?.Label}</option>
                                        ))
                                    }
                            </select>
                        </Accordion.Body>
                    </Accordion.Item> 

                    <Accordion.Item eventKey="2">
                        <Accordion.Header onClick={() => setActiveSection('2')}>
                            <div className='form-group required p-0'>
                                <label className="label" htmlFor='' style={{fontWeight: 600, marginRight:"1rem", display: "inline-block"}}>Within what timeframe are you looking to close the transaction?</label>{" "}<span className="hidable">{props?.dataTimeframes?.data?.find((el: any) => el?.id == formState?.transaction_duration)?.attributes?.Label}</span>
                                {
                                    props?.errorTransaction && (
                                        <div className="container-error pl-2  d-inline" style={{color: 'red'}}>
                                            <span className='error-red'> ERROR </span>{" "}
                                            <span className='txt-error'>This field is required</span>
                                        </div>
                                    )
                                }
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <select className='form-control mt-2'
                                name='transaction_duration'
                                onChange={(evt) => updateState(evt.target.name, evt.target.value)}
                            >
                                <option value={0}>Select an option ...</option>
                                    {
                                        props?.dataTimeframes?.data?.map((el : any, index : any) => (
                                            <option selected={el?.id == formState?.transaction_duration} value={el?.id} key={index}>{el?.attributes?.Label}</option>
                                        ))
                                    }
                            </select>
                        </Accordion.Body>
                    </Accordion.Item> 

                </Accordion>
                
            </Modal.Body>
            <Modal.Footer>
                <div className='text-align-right'>
                    {!isAccordionOpen && (
                        <>
                            <button
                                style={{ marginLeft: "1rem" }}
                                className='btn btn-devinsider save'
                                onClick={() => handleExit()}>
                                Close
                            </button>
                        </>
                    )}
                    {isAccordionOpen && (
                        <>
                            <button
                                style={{ marginLeft: "1rem" }}
                                className='btn btn-devinsider cancel'
                                onClick={() => !props.isLoading && handleExit()}>
                                Cancel
                            </button>
                            <button
                               className='btn btn-devinsider save'
                                onClick={() => !props.isLoading && save()}>
                            
                                {props.isLoading ? <Loader/> : "Save"}
                            </button>
                        </>
                    )}
                </div>
            </Modal.Footer>

        </Modal>
    )
}